// mirrors the loaded agent's agency logos into localStorage so pre-login screens
// can already paint the right branding. sunshine only, and never while impersonating
import { getCompany } from 'helpers/getCompanyVariables';
import {
  LOGO_TONES,
  hasLoadedAgent,
  selectAgencyLogoUrl
} from 'helpers/brandLogo';
import { writeRememberedAgencyLogos } from 'lib/agencyLogoStorage';

const isSunshine = getCompany() === 'sunshine';

function readAgencyLogos(zohoData) {
  return Object.fromEntries(
    LOGO_TONES.map(tone => [tone, selectAgencyLogoUrl(zohoData, tone)])
  );
}

/**
 * subscribes to the store and keeps the remembered agency logos in sync
 * @param store - the redux store
 * @param storage - Storage-like object, defaults to window.localStorage
 */
export default function rememberAgencyLogo(store, storage) {
  if (!isSunshine) return () => {};

  let lastWritten = null;

  return store.subscribe(() => {
    const { zohoData, viewAsAgent, mainZohoId } = store.getState().user;

    // same rule as persistUserState: localStorage is shared by every tab of the
    // origin and view-as opens a new tab, so the impersonated agency must not
    // overwrite what the admin's own tabs and login screen rely on
    if (viewAsAgent) return;

    // during the exit-view-as gap, viewAsAgent is already null but zohoData still
    // belongs to the impersonated agent — compare ids to catch that window
    if (mainZohoId && zohoData?.id !== mainZohoId) return;

    // an empty slice means signed out, not "this agency dropped its logos", so
    // CLEAN_USER on logout has to leave the remembered values alone
    if (!hasLoadedAgent(zohoData)) return;

    const logos = readAgencyLogos(zohoData);
    const serialized = JSON.stringify(logos);
    // the subscriber runs on every dispatch; only touch storage on a real change
    if (serialized === lastWritten) return;

    lastWritten = serialized;
    writeRememberedAgencyLogos(logos, storage);
  });
}
